import * as CommonDashboardFuncs from "dashboard-style-airframe"

export default CommonDashboardFuncs
